module.exports = __webpack_public_path__ + "media/colors/JASPEM2-2-bb99cdbc.png";